import { CONTENT_MAX_WIDTH, CONTENT_MIN_WIDTH, CONTENT_WIDTH_RATIO } from '../../config/designSystem/Layout';
import { useAvailableDimensions } from './useAvailableDimensions';

/**
 * Width of the reading column of sessions and activity pages, from the space
 * actually available (the web side menu excluded), not from the platform: the
 * whole width on a phone, a growing share of the screen above that, capped so
 * lines stay readable on a large monitor.
 */
export const useContentMaxWidth = (): number => {
  const { width } = useAvailableDimensions();
  const target = Math.round(width * CONTENT_WIDTH_RATIO);
  return Math.min(width, Math.max(CONTENT_MIN_WIDTH, Math.min(target, CONTENT_MAX_WIDTH)));
};
